import { Image, useIntl } from 'platform-components';
import React from 'react';

import { SpecCourseLessonViewSectionContent } from 'common.components/spec-course-lesson-view/__section-content/spec-course-lesson-view__section-content';
import { SpecCourseLessonViewSectionDescription } from 'common.components/spec-course-lesson-view/__section-description/spec-course-lesson-view__section-description';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';
import { SpecCourseLessonViewStub } from 'common.components/spec-course-lesson-view/__stub/spec-course-lesson-view__stub';

import { SpecCourseResultsTitle } from '../__title/results__title';

import './results__not-available-stub.scss';

export const SpecCourseResultsNotAvailableStub = () => {
    const intl = useIntl();
    const resultsStubImage = intl.formatMessage({ id: 'specCourse.lessonView.resultsTable.stubImg' });
    const resultsStubImageAlt = intl.formatMessage({ id: 'specCourse.lessonView.resultsTable.stubImgAlt' });

    return (
        <SpecCourseLessonViewSection>
            <SpecCourseResultsTitle />
            <SpecCourseLessonViewSectionDescription id="specCourse.lessonView.resultsTable.resultsAreNotAvailable.description" />
            <SpecCourseLessonViewSectionContent>
                <SpecCourseLessonViewStub>
                    <Image
                        alt={resultsStubImageAlt}
                        className="spec-course-results__not-available-stub-img"
                        src={resultsStubImage}
                    />
                </SpecCourseLessonViewStub>
            </SpecCourseLessonViewSectionContent>
        </SpecCourseLessonViewSection>
    );
};
